import { render } from "./FooterButton.vue?vue&type=template&id=7ebe84c3"
import script from "./FooterButton.vue?vue&type=script&lang=js"
export * from "./FooterButton.vue?vue&type=script&lang=js"

import "./FooterButton.vue?vue&type=style&index=0&id=7ebe84c3&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__